import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import {
  getDeviceList,
  deleteData,
  getSiteListByManufacturerID,
  getMultipleManufacturerList,
} from "../../Utils/adminFunctions";
import { getDataArr } from "../../Utils/commonFunctions";
import dataTableGrid from "../DataTableGrid";

const AdminListDevices = () => {
  const [listDevices, setListDevices] = useState([]);
  const [listCompanies, setListCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [listSites, setListSites] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  useEffect(() => {
    manageDevice();
    getManufacturerList();
  }, []);
  const manageDevice = async () => {
    let selectedCompaniesArr = getDataArr(selectedCompanies);
    let selectedSitesArr = getDataArr(selectedSites);
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", selectedCompaniesArr);
    bodyFormData.append("site_ids", selectedSitesArr);
    const response = await getDeviceList(bodyFormData);
    if (response.status === "success" || response.status === "failure") {
      setListDevices(response.optionItems);
      dataTableGrid({
        data_table_id: "#devicelist",
        paginate: false,
        copy_option: [0, 2, 3, 4, 5, 6],
        csv_option: [0, 2, 3, 4, 5, 6],
        print_option: [0, 2, 3, 4, 5, 6],
        sort_option: [1, 7],
      });
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const getManufacturerList = async () => {
    const response = await getMultipleManufacturerList();
    if (response.status === "success") {
      setListCompanies(response.optionItems);
    } else {
      setListCompanies([]);
    }
  };
  const handleDeviceDeleteRecord = async () => {
    let dID = document.getElementById("deleteDevice").value;
    const response = await deleteData(dID, "DEVICE");
    if (response.status == "success") {
      manageDevice();
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };

  const filterDevice = async () => {
    if (selectedCompanies.length == 0) {
      return false;
    }
    manageDevice();
  };

  const refreshDevice = () => {
    selectedCompanies.length = 0;
    selectedSites.length = 0;
    setListSites([]);
    setSelectedCompanies([]);
    setSelectedSites([]);
    manageDevice();
  };

  const getSites = async (e) => {
    if (e.length === 0) {
      setListSites([]);
      setSelectedSites([]);
      return false;
    }
    let selectedCompaniesArr = getDataArr(e);
    const bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", selectedCompaniesArr);
    const response = await getSiteListByManufacturerID(bodyFormData);
    if (response.status === "success") {
      setListSites(response.optionItems);
    } else {
      setListSites([]);
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div className="modal fade show" id="modal-default" arial-modal="true">
          <input type="hidden" id="deleteDevice" value=""></input>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm delete</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close_modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="btn btn-sm btn-dark"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDeviceDeleteRecord()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-3">
                            <MultiSelect
                              options={listCompanies}
                              value={selectedCompanies}
                              onChange={(e) => {
                                getSites(e);
                                setSelectedCompanies(e);
                              }}
                              labelledBy="Select"
                            />
                          </div>

                          <div className="col-md-3">
                            <MultiSelect
                              options={listSites}
                              value={selectedSites}
                              onChange={(e) => {
                                setSelectedSites(e);
                              }}
                              labelledBy="Select"
                            />
                          </div>

                          <div className="col-md-3">
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => filterDevice()}
                            >
                              <i className="fa fa-search" aria-hidden="true" />{" "}
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => refreshDevice()}
                            >
                              <i className="fa fa-refresh" aria-hidden="true" />{" "}
                            </button>
                          </div>
                          <div className="col-md-3">
                            <h3 className="card-title card-header-link pull-right">
                              <Link
                                to="/AdminAddDevice"
                                className="custom-link-primary"
                              >
                                <b>+ Add Device</b>
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="devicelist"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Device Image</th>
                              <th>Device ID</th>
                              <th>Device Name</th>
                              <th>Company Name</th>
                              <th>Site Name</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listDevices}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListDevices;
